<template>
  <span
      class="badge"
      :class="[dynamicClass, extraClass, { 'position-absolute': absolute }]"
      role="status"
  >
    {{ $t(`products.labels.${text}`) }}
  </span>
</template>

<script setup>
const props = defineProps({
    text: {
        type: String,
        required: true
    },
    absolute: Boolean,
    extraClass: String
})

const dynamicClass = computed(() =>
    `badge-${props.text.toLowerCase().replace(/\s+/g, '-')}`
)
</script>
